// Imports
import BannerWithList from '../../../resources/banner-with-list';
import items from './items';


// Function component
const WhyHOAExpress: React.FC = () => <BannerWithList items={items} heading='Why HOA Express stands out' />;

export default WhyHOAExpress;
